import * as React from 'react'
import type { SVGProps } from 'react'
import { cn } from '../../../utils/utils'

const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 32 32"
        {...props}
        className={cn('inline-block relative -top-px', props.className)}
    >
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 16h22M16 5v22" />
    </svg>
)
export default SvgPlus
